import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useScene } from "./scene/SceneController";
import ModalPopup from "../../../components/popups/DefaultPopUp";

const CTASection = () => {
    const brandName = process.env.REACT_APP_BRAND_NAME;
    const [showDemoModal, setShowDemoModal] = useState(false);
    const { updateScene } = useScene();

    useEffect(() => {
        updateScene({
            section: "cta",
            chaos: 0,
            organization: 1,
            coreIntensity: 5,
            cameraDistance: 5,
        });
    }, [updateScene]);

  return (
    <section
      id="cta"
      className="
        tw-relative
        tw-min-h-[75vh]
        tw-flex
        tw-items-center
        tw-justify-center
        tw-overflow-hidden
        tw-px-6
      "
    >
      {/* Background */}

      <div
        className="
          tw-absolute
          tw-inset-0
          tw-bg-gradient-to-br
          tw-from-[#020617]
          tw-via-blue-950
          tw-to-[#020617]
        "
      />

      {/* Animated light */}

      <motion.div
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.25, 0.5, 0.25],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
        }}
        className="
          tw-absolute
          tw-w-[600px]
          tw-h-[600px]
          tw-rounded-full
          tw-bg-cyan-500/20
          tw-blur-[120px]
        "
      />

      <div
        className="
          tw-relative
          tw-z-10
          tw-max-w-4xl
          tw-text-center
        "
      >
        <motion.div
          initial={{
            opacity: 0,
            y: 40,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 0.8,
          }}
        >
          <p
            className="
              tw-text-cyan-400
              tw-uppercase
              tw-tracking-[0.3em]
              tw-text-sm
              tw-mb-6
            "
          >
            Ready for the next generation firm?
          </p>

          <h2
            className="
              tw-text-4xl
              md:tw-text-6xl
              tw-font-bold
              tw-text-white
              tw-leading-tight
            "
          >
            Give your accountants
            <br />
            the technology to
            <br />
            <span
              className="
                tw-bg-gradient-to-r
                tw-from-cyan-400
                tw-to-blue-400
                tw-bg-clip-text
                tw-text-transparent
              "
            >
              work at their best.
            </span>
          </h2>

          <p
            className="
              tw-mt-8
              tw-text-lg
              md:tw-text-xl
              tw-text-gray-300
              tw-max-w-3xl
              tw-mx-auto
            "
          >
            {brandName} handles the repetitive operational workload while your team focuses on judgement, advisory and creating more value for clients.
          </p>

          <div
            className="
              tw-mt-10
              tw-flex
              tw-flex-col
              sm:tw-flex-row
              tw-justify-center
              tw-gap-5
            "
          >
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0 0 40px rgba(34,211,238,.7)" }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setShowDemoModal(true)}
              className="
                tw-px-10
                tw-py-4
                tw-rounded-xl
                tw-bg-gradient-to-r
                tw-from-cyan-500
                tw-to-blue-600
                tw-text-white
                tw-font-semibold
                tw-shadow-xl
              "
            >
              Book a Demo
            </motion.button>

            <motion.button
              whileHover={{
                scale: 1.05,
              }}
              className="
                tw-px-10
                tw-py-4
                tw-rounded-xl
                tw-bg-white/10
                tw-backdrop-blur-xl
                tw-border
                tw-border-white/20
                tw-text-white
                tw-font-semibold
              "
            >
              Join Waitlist
            </motion.button>
          </div>

          {/* Trust points */}

          <div
            className="
              tw-mt-12
              tw-flex
              tw-flex-wrap
              tw-justify-center
              tw-gap-6
              tw-text-sm
              tw-text-gray-400
            "
          >
            <span>✓ Keep full professional control</span>

            <span>✓ Reduce repetitive work</span>

            <span>✓ Empower your team</span>
          </div>
        </motion.div>
      </div>

      <ModalPopup
        isOpen  = { showDemoModal }
        onClose = { () => setShowDemoModal(false) }
        title   = { `Book a ${brandName} Demo` }
        subtext = { `Ready to boost your firm's output? Call us at +91 97709 69714 to schedule your live ${brandName} demo and see how automation transforms your workflow.`}
        cancelText = "Maybe Later"
        actionText = "Connect Instantly"
        onAction   = { () => {
          window.location.href = "tel:+1234567890"; // Opens the dialler
          setShowDemoModal(false);                  // Closes the popup 
        }}
      />
    </section>
  );
};

export default CTASection;